import { MediaQueries } from '@hhgtech/hhg-components/misc'
export const display = `
.d-none-mb-down {
  ${MediaQueries.mbDown} {
    display: none;
  }
}
.d-none-mb-up {
  ${MediaQueries.mbUp} {
    display: none;
  }
}
`
